import { tdsFetch } from '@/utils/fetch';

const sysPrefix = '/system';

export const loginApi = (data) => tdsFetch(sysPrefix + '/sys/login', { method: 'POST', body: data, ignoreToken: true, joinPrefix: false })

export const getUserInfo = () => tdsFetch(sysPrefix + '/sys/user/getUserInfo', { method: 'GET', joinPrefix: false })

export const getUserPermission = () => tdsFetch(sysPrefix + '/sys/permission/getUserPermissionByToken', { method: 'GET', joinPrefix: false })

export const registerApi = (data) => tdsFetch(sysPrefix + '/sys/user/register', { method: 'POST', body: data, ignoreToken: true, joinPrefix: false })

export function updateUserInfo(data) {
  return tdsFetch(sysPrefix + '/sys/user/login/setting/userEdit2', {
    method: 'POST',
    body: data,
    joinPrefix: false 
  })
}

export function updatePassword(data) {
  return tdsFetch(sysPrefix + '/sys/user/changePassword2', {
    method: 'PUT',
    body: data,
    joinPrefix: false 
  })
}
